import Vue from 'vue'
import moment from 'moment'
moment.locale('id')

// Vue.filter('settingShow', function(data){
//     if (data.semsester == 0) return '-'
//     let semester = data.semester == 1 ? 'Ganjil' : 'Genap'
//     return `Semester ${semester} ${data.year}/${data.year + 1}`
// })

// Vue.filter('semesterShow', function(data){
//     if (data == 0) return '-'
//     return data == 1 ? 'Ganjil' : 'Genap'
// })

// Vue.filter('yearShow',function(data){
//     if (data == 0) return '-'
//     return `${data}/${data + 1}`
// })

// Vue.filter('downloadFile',function(path_file){
//     return `${process.env.VUE_APP_API_WEB_URL}/storage/${path_file}`
// })

Vue.filter('getDateIndo',function(date){
    return moment(date).format("DD MMMM YYYY")
})

Vue.filter('getDateIndoWithDay',function(date){
    return moment(date).format("dddd, DD MMMM YYYY")
})

Vue.filter('getDateIndoWithDayAndTime',function(date){
    return moment(date).format("DD/MMMM/YYYY hh:mm:ss") + " WIB"
})

Vue.filter('getDiffDateIndo', function(date) {
    let given = moment(date, "YYYY-MM-DD")
    let current = moment().startOf('day')

    //Difference in number of days
    let diffDays = moment.duration(given.diff(current)).asDays()
    if (diffDays < 0) {
        return 'Sudah Terlaksana'
    } else if (diffDays > 0) {
        return `${diffDays} Hari Lagi`
    } else {
        return 'Hari Ini'
    }
})

Vue.filter('getCurrencyIndo',function(number){
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0,
    maximumFractionDigits: 0 }).format(number)
})

Vue.filter('checkReadMore',function(str) {
    return str.length > 160 ? '......' : '';
})


